import React from "react";

const Kotlin_When = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Kotlin When</h1>
      <p>Content for Kotlin When goes here.</p>
    </div>
  );
};

export default Kotlin_When;
